import type { CVRParticipant } from '../types'

/** Badge text for a participant role; normalises stifter labels to "Stifter". */
export function roleBadgeLabel(role: CVRParticipant['role']): string | null {
  const raw =
    role.function && role.function.trim() !== ''
      ? role.function.trim()
      : (role.organizationType?.trim() ?? '')
  if (!raw) return null
  if (/^stiftere$/i.test(raw) || /^stifter$/i.test(raw)) {
    return 'Stifter'
  }
  return raw
}
